module.exports = __webpack_public_path__ + "static/amordemi-46aa15443c045a812cacece4508d78e9.png";